module.exports = __webpack_public_path__ + "static/media/logoBig.83decec0.svg";